var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfilePhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.817871 16.7273C0.817871 15.0878 1.46917 13.5154 2.62848 12.3561C3.7878 11.1968 5.36017 10.5455 6.99969 10.5455C8.63921 10.5455 10.2116 11.1968 11.3709 12.3561C12.5302 13.5154 13.1815 15.0878 13.1815 16.7273H11.6361C11.6361 15.4976 11.1476 14.3184 10.2781 13.4489C9.40861 12.5794 8.22933 12.0909 6.99969 12.0909C5.77005 12.0909 4.59077 12.5794 3.72129 13.4489C2.8518 14.3184 2.36333 15.4976 2.36333 16.7273H0.817871ZM6.99969 9.77273C4.4381 9.77273 2.36333 7.69795 2.36333 5.13636C2.36333 2.57477 4.4381 0.5 6.99969 0.5C9.56128 0.5 11.6361 2.57477 11.6361 5.13636C11.6361 7.69795 9.56128 9.77273 6.99969 9.77273ZM6.99969 8.22727C8.70742 8.22727 10.0906 6.84409 10.0906 5.13636C10.0906 3.42864 8.70742 2.04545 6.99969 2.04545C5.29196 2.04545 3.90878 3.42864 3.90878 5.13636C3.90878 6.84409 5.29196 8.22727 6.99969 8.22727Z",
    fill: "#090909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfilePhoto);
export default __webpack_public_path__ + "static/media/user-profile-photo.5c4ec1745317430f9c532ecf36068522.svg";
export { ForwardRef as ReactComponent };